import { useCMSPageField } from '@/cms/fields'
import { ProductAdsComponent } from '@/scopes/product-ads/components/ProductAdsLegacy'
import { ProductAdsListLegacy } from '@/scopes/product-ads/components/ProductAdsListLegacy'
import { useDestinationFilteredProductAds, useProductAdsListViewed } from '@/scopes/product-ads/domain/hooks'
import { tk } from '@sunwebgroup/ui-components'
import { useRef } from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  padding: ${tk('spacing_lg')} ${tk('spacing_md')};
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 12px;
  border: 2px solid #e7e0d7;

  margin-bottom: ${tk('spacing_md')};

  @media ${tk('mq_tablet')} {
    margin-bottom: ${tk('spacing_lg')};
  }

  @media ${tk('mq_desktop_sm')} {
    padding: ${tk('spacing_3xl')};
    margin-bottom: ${tk('spacing_xl')};
  }
`

export function AccoTileProductAds({
  infoLabel,
  infoContent,
  contextItemId,
  headerTitle,
}: {
  infoLabel: string
  infoContent: string
  headerTitle: string
  contextItemId: string
}) {
  const regionId = useCMSPageField('PDP.regionId')
  const { isLoading, data } = useDestinationFilteredProductAds({
    contextItemId,
    destinations: { Region: [regionId] },
    componentType: 'AccoList',
  })
  const productAdsRef = useRef(null)
  useProductAdsListViewed(data, 'sponsored_pdp', productAdsRef)

  const content = !data || data.length === 0
    ? null
    : (
        <Wrapper data-qa="product-ads">
          <ProductAdsComponent infoLabel={infoLabel} infoContent={infoContent} headerTitle={headerTitle}>
            <ProductAdsListLegacy data={data} isLoading={isLoading} type="sponsored_pdp" />
          </ProductAdsComponent>
        </Wrapper>
      )

  return <div ref={productAdsRef}>{content}</div>
}
